import dayjs from "dayjs";
import { LIVE_SHARE_DESIGN_WIDTH } from "./constants";

const win: any = window;

const screenWidth =  window.screen.width;
const calcLiveShareRatio = (size: number) =>
  (size * screenWidth) / LIVE_SHARE_DESIGN_WIDTH;

/** 背景日期文案：设计稿 left 240 / top 306 / font 13（与 fifaGetCoupon RATIOS 同一套换算） */
export const LIVE_SHARE_DATE_LABEL_LAYOUT = {
  left: calcLiveShareRatio(245),
  top: calcLiveShareRatio(247),
  fontSize: calcLiveShareRatio(13),
};

/** 当前日期，如 4月15日（与红包页 Top 展示习惯一致，无前导零） */
export const formatLiveShareCurrentDate = () => dayjs().format("M月D日");

export const goTrick = (title = "打开看看") => {
  win?.sensors?.track("buttonClick", {
    belong_page: "直播间分享页",
    button_name: title,
    page_source: "直播间分享页",
  });
};
